export function encodeNull(): void {
}
